import styled from 'styled-components'

export const Span = styled.span``

interface LoaderContainerProps {
  active: boolean;
}

export const LoaderContainer = styled.div<LoaderContainerProps>`
    width: 100%;
    height: 100vh;
    display: ${props => props.active ? 'flex' : 'none'};
    justify-content: center;
    align-items: center;
    position: fixed;
    background: rgba(0, 0, 0, 0.30);
    z-index: 10;
    img {
        width: 50px;
        height: 50px;
    }
`